import React from 'react';
import {
  Plans,
  PlansLabel,
  PlansDiv,
  Plan,
  TitlePlan,
  SubTitlePlan,
  OldPrice,
  NewPrice,
  ListAdvantagesPlan,
  Advantage,
  IconAdvantage,
  LabelAdvantage,
  LabelDisclaimer,
  ButtonPlan,
  Price,
  DetailsPrice,
} from './styles';

import { push } from '../../../services/navigate';
import { useDispatch, useSelector } from 'react-redux';
import { setActiveStep } from '../../../redux/actions/utils.actions';
import { setCurrentPlan } from '../../../redux/actions/buy.actions';


export default function App({ plansAPI, plansJSON }) {
  const dispatch = useDispatch();

  const user = useSelector((state) => state.userReducer.user);

  function setPlan(plan) {
    dispatch(setCurrentPlan(plan));
    dispatch(setActiveStep(2));
    localStorage.setItem('@current_plan', JSON.stringify(plan));

    if (user && user.name) {
      return push(`/comprar/${plan.namePlan}`);
    }

    localStorage.setItem('buy-flag', 'true');
    return push(`/cadastro/${plan.namePlan}`);
  }

  return (
    <Plans id="contratos" src="img/contratos.png">
      <PlansLabel>contratos e valores</PlansLabel>
      <PlansDiv>
        {plansAPI &&
          plansAPI.length > 0 &&
          plansAPI.map((planAPI) => {
            let plan = plansJSON[planAPI.category];
            if (plan) {
              return (
                <Plan>
                  <TitlePlan>{plan.namePlan}</TitlePlan>
                  <SubTitlePlan>{plan.typePlan}</SubTitlePlan>

                  {plan.oldPrice && (
                    <OldPrice>
                      de <b>R$ {plan.oldPrice},00</b>
                    </OldPrice>
                  )}

                  
                  <NewPrice>
                      <Price>R$ {plan.newPrice}</Price>
                      <DetailsPrice>
                        <p>,{plan.newCentPrice}</p>
                        <span>{plan.labelTypePlan}</span>
                      </DetailsPrice>
                    </NewPrice>

                    <ListAdvantagesPlan>
                      {plan.advantages.map((advantage) => (
                        <Advantage>
                          <IconAdvantage src="/img/tick.png" />
                          <LabelAdvantage>{advantage}</LabelAdvantage>
                        </Advantage>
                      ))}
                    </ListAdvantagesPlan>

                    <ButtonPlan
                      namePlan={plan.namePlan}
                      onClick={() => setPlan({ ...plan, ...planAPI })}
                  >
                    Contrate agora
                  </ButtonPlan>
                  { plan.disclaimer && <LabelDisclaimer>{plan.disclaimer}</LabelDisclaimer> }
                </Plan>
              );
            }
          })}
      </PlansDiv>
    </Plans>
  )}

